import React, { useEffect, useState, useRef } from "react";

const FAQs = () => {
  const faqData = [
    {
      title: "Certification",
      questions: [
        "1. What are the principles of total quality management? Explain.",
        "2. Why total quality management is important to an organization?",
        "3. WHAT IS HAZARD ANALYSIS CRITICAL CONTROL POINT (HACCP)?",
        "4. What is renewal audit?",
        "5. How do you know if your ISO certification is up for renewal?",
      ],
    },
    {
      title: "Knowledge",
      questions: [
        "1. What is Annex SL and why it is used?",
        "2. What is the Annex SL System Structure?",
        "3. What was the Vision behind Annex SL?",
        "4. What benefit is there to harmonization?",
        "5. Who Created Annex SL?",
        "6. What is the ISO High-Level Structure?",
        "7. How does Annex SL help in audits?",
        "8. What is Annex SL and why it is used?",
        "9. What is the Annex SL System Structure?",
        "10. What was the Vision behind Annex SL?",
      ],
    },
  ];

  return (
    <section className="bg-gray-100 py-8 sm:py-10 px-3 sm:px-6 md:px-10">
      <div>
        <h2 className="w-full bg-gradient-to-r from-[#0070a8] to-[#023955] text-center font-semibold tracking-wide text-white mb-6 py-2 text-lg sm:text-xl md:text-2xl lg:text-3xl">
          FAQs
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 md:gap-10">
          {faqData.map((faq, index) => (
            <FAQCard key={index} title={faq.title} questions={faq.questions} />
          ))}
        </div>
      </div>
    </section>
  );
};

const FAQCard = ({ title, questions }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [itemHeight, setItemHeight] = useState(0);
  const listRef = useRef(null);
  const shouldScroll = questions.length > 5;

  useEffect(() => {
    if (listRef.current) {
      const firstItem = listRef.current.querySelector("li");
      if (firstItem) {
        setItemHeight(firstItem.offsetHeight + 8);
      }
    }
  }, [questions]);

  useEffect(() => {
    if (shouldScroll && itemHeight) {
      const interval = setInterval(() => {
        setCurrentIndex((prev) => (prev + 1) % questions.length);
      }, 2500);
      return () => clearInterval(interval);
    }
  }, [questions.length, shouldScroll, itemHeight]);

  return (
    <div className="bg-white shadow-md rounded-md overflow-hidden">
      <div className="bg-gradient-to-r from-[#0070a8] to-[#023955] hover:to-[#1674a3] text-white font-semibold px-4 py-3 text-sm sm:text-base md:text-lg">
        {title}
      </div>

      <div
        className="relative overflow-hidden px-2 py-2"
        style={{
          height: itemHeight ? `${itemHeight * 5}px` : "12rem",
        }}
      >
        <ul
          ref={listRef}
          className="transition-transform duration-300 ease-out"
          style={{
            transform: `translateY(-${currentIndex * itemHeight}px)`,
          }}
        >
          {(shouldScroll
            ? [...questions, ...questions.slice(0, 5)]
            : questions
          ).map((q, idx) => (
            <React.Fragment key={idx}>
              <li className="flex items-center px-3 sm:px-4 md:px-6 py-2 hover:bg-gray-50 cursor-pointer rounded-md text-sm sm:text-base md:text-base">
                {q}
              </li>
              {/* Horizontal line */}
              {idx !== questions.length - 1 && (
                <hr className="border-gray-200 my-1" />
              )}
            </React.Fragment>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default FAQs;
